import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  POST: 'SUBSCRIPTION_PAYMENT_LINK_POST',
  POST_SUCCESS: 'SUBSCRIPTION_PAYMENT_LINK_POST_SUCCESS',
  POST_FAILURE: 'SUBSCRIPTION_PAYMENT_LINK_POST_FAILURE',
};

export const post = actions.post(
  (id, value, { studentId }) =>
    `${BASE_URL}/students/${studentId}/subscription-payment-link/`,
  {
    PENDING: ACTIONS.POST,
    SUCCESS: ACTIONS.POST_SUCCESS,
    FAILURE: ACTIONS.POST_FAILURE,
  },
);
